/**
 * Created by Languagenut on 23/09/2019.
 */

import React  from 'react';
import {Form } from 'react-bootstrap'
import {ProductStore} from '../store';
import Constants from '../constants.js';
import Translation from '../store/internationalization-store.js';
export default class LanguageSelect  extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            languages:[],
        }
    }

    componentWillReceiveProps(props){
        if (this.props.limitLanguages != props.limitLanguages) {
                this.props = props;
                this.updateLanguageFilter();
        }
        this.props = props;

        this.setState({
            "update":true
        });
    }

    setInitial(newLanguages) {
        this.state.languages = newLanguages;
        if (this.isDuplicates()) {
            var getList = [];
            newLanguages.map(function(language){
                if(getList.indexOf(language.curriculum_note) < 0) {
                    getList.push(language.curriculum_note);
                }
            })
            getList.sort();

            var first = getList[0];

            for (var $i = 0; $i < newLanguages.length; $i++) {
                var language = newLanguages[$i];
                if (language.curriculum_note != undefined && language.curriculum_note != "") {
                    if (language.curriculum_note == first) {
                        this.props.returnValue(ProductStore.getCurriculumLanguage(language.ietf, language.curriculumUid));
                        break;
                    }
                }
            }
        } else {
            this.props.returnValue(ProductStore.getCurriculumLanguage(newLanguages[0].ietf, newLanguages[0].curriculumUid));
        }
    }

    updateLanguageFilter() {
        const allLanguage = {
            alignRight: "0",
            baseName: "All",
            bronzeMedals: 0,
            curriculumUid: "",
            curriculum_name: "",
            goldMedals: 0,
            hasAudio: "1",
            hasSentence: "1",
            hasSpeaking: "1",
            ietf: "all",
            isEAL: "0",
            isInterface: "0",
            isPriority: "1",
            name: "12230",
            packageUid: "8",
            silverMedals: 0
        };

        const english = {
            alignRight: "0",
            baseName: "English",
            bronzeMedals: 0,
            curriculumUid: "",
            curriculum_name: "",
            goldMedals: 0,
            hasAudio: "1",
            hasSentence: "1",
            hasSpeaking: "1",
            ietf: "en",
            isEAL: "0",
            isInterface: "0",
            isPriority: "1",
            name: "45",
            silverMedals: 0
        };

        var languages = ProductStore.getLearningLanguages();
        if (this.props.isInterface) {
            languages = ProductStore.getInterfaceLanguages();
        }
        var first = this.props.priority;
        languages = languages.sort(function(x,y){ console.log(x); return x.ietf == first ? -1 : y.ietf == first ? 1 : 0; });

        if (this.props.addAll == true) {
            languages.unshift(allLanguage);
        }
        if (this.props.limitLanguages != undefined && this.props.limitLanguages.length > 0) {
            var languagesNew = [];
            for (var i =0; i < this.props.limitLanguages.length; i++) {
                var limiter = this.props.limitLanguages[i].value;
                if (limiter == undefined) {
                    limiter = this.props.limitLanguages[i];
                }
                for (var j =0; j < languages.length; j++) {
                    if (languages[j].ietf == limiter || 
                        ((languages[j].ietf == "en" || languages[j].ietf == "en-au" || 
                                languages[j].ietf == "en-nz" || languages[j].ietf == "en-us" || languages[j].ietf == "en-ca") 
                        && (limiter == "en" || limiter == "en-au" || limiter == "en-nz" || limiter == "en-us" || limiter == "en-ca"))) {
                        languagesNew.push(languages[j]);
                    }
                }
            }
            if (this.props.returnValue != undefined && languagesNew[0] != undefined) {
                this.setInitial(languagesNew);
            }
            this.setState({
                languages:languagesNew
            })
            return;
        } else if (this.props.disabledLanguages != undefined && this.props.disabledLanguages.length > 0) {
            var languagesNew = [];
            for (var j =0; j < languages.length; j++) {
                var isDisabled = false;
                for (var i =0; i < this.props.disabledLanguages.length; i++) {
                    var limiter = this.props.disabledLanguages[i];
                    if (languages[j].ietf == limiter) {
                        isDisabled = true;
                        continue;
                    }
                }

                if (!isDisabled) {
                    languagesNew.push(languages[j]); 
                }
            }
            
            if (this.props.returnValue != undefined && languagesNew[0] != undefined) {
                this.setInitial(languagesNew);
            }
            this.setState({
                languages:languagesNew
            })
            return;
        } else {
            if (this.props.returnValue != undefined && languages[0] != undefined) {
                this.setInitial(languages);
            }
            if (!(this.props.limitLanguages != undefined && this.props.limitLanguages.length > 0)) {
                this.setState({
                    languages:languages
                })
            }
        }
    }

    componentWillMount(){
        this.updateLanguageFilter();
        ProductStore.on(Constants.GET_LANGUAGES ,  ()=>{
            this.updateLanguageFilter();
        });
    }

    updateLanguage(event) {
        if (this.props.returnValue != undefined) {
            var dataLanguage  = event.target.value.split("-");
            if (dataLanguage[1] != undefined && !Number.isInteger(parseInt(dataLanguage[1]))){
                if (dataLanguage[2] != undefined) {
                    this.props.returnValue(ProductStore.getCurriculumLanguage(dataLanguage[0]+"-"+dataLanguage[1], dataLanguage[2]));
                } else {
                    this.props.returnValue(ProductStore.getCurriculumLanguage(event.target.value, undefined));
                }
            } else {
                this.props.returnValue(ProductStore.getCurriculumLanguage(dataLanguage[0],dataLanguage[1]));
            }
        }
    }

    isDuplicates() {
        if (this.props.singularOnly == true) {
            return false;
        }
        var runningTotal = [];
        for (var i = 0; i < this.state.languages.length; i++) {
            if (runningTotal.indexOf(this.state.languages[i].ietf) == -1) {
                runningTotal.push(this.state.languages[i].ietf);
            } else {
                return true;
            }
        }
        return false;
    }

    notDisabled() {
        var lable = this.props.title ?   <Form.Label>{this.props.title}</Form.Label> : null;
        if (this.isDuplicates()) {
            var lable = this.props.title ?   
            [<Form.Label style={{width:"52%", float:"left"}}><b>{Translation.get(0, "Select Product")}</b></Form.Label>,
            <Form.Label style={{width:"48%", float:"right"}}>{this.props.title}</Form.Label>] : null;

            function clone(obj) {
                if (null == obj || "object" != typeof obj) return obj;
                var copy = obj.constructor();
                for (var attr in obj) {
                    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
                }
                return copy;
            }

            var newStyle = clone(this.props.style);
            if (newStyle == null || newStyle == undefined) {
                newStyle = {};
            }
            newStyle.width = "48%";
            newStyle.float = "left";
            var getList = [];
            var curriculumTests = [];
            var languages = [];


            this.state.languages.map(function(language){
                if(getList.indexOf(language.curriculum_note) < 0) {
                    getList.push(language.curriculum_note);
                }
            })
            getList.sort();

            for (var i =0; i < getList.length; i++) {
                curriculumTests.push(<option value={getList[i]}>{getList[i]}</option>);
            }

            if (this.state.selectedCurricNote == undefined) {
                this.state.selectedCurricNote = getList[0];
            }

            var first = "";

            var languages = this.state.languages.map(function(language){
                if (language.curriculum_note != undefined && language.curriculum_note != "") {
                    if (language.curriculum_note != this.state.selectedCurricNote && this.state.selectedCurricNote != undefined) {
                        return "";
                    }
                    if (first == "") {
                        first = language.ietf+"-"+language.curriculumUid;
                    }
                    return <option value={language.ietf+"-"+language.curriculumUid}>{Translation.get(language.name , language.basename) + " - " + language.curriculum_note}</option>
                } else {
                    return <option value={language.ietf+"-"+language.curriculumUid}>{Translation.get(language.name , language.basename)}</option>
                }
            }.bind(this));

            if (first != "" && this.state.needUpdate == true) {
                this.state.needUpdate = false;
                this.updateLanguage({target:{value:first}});
            }

            return <Form.Group controlId="exampleForm.ControlSelect1">
                {lable}
                <Form.Control style={newStyle} as="select" onChange={function(event) {
                    this.setState({selectedCurricNote:event.target.value, needUpdate:true});
                }.bind(this)}>
                   {curriculumTests};
                </Form.Control>
                <span style={{width:"4%", float:"left", color:"#FFFFFF"}}>.</span>
                <Form.Control style={newStyle} as="select" onChange={this.updateLanguage.bind(this)}>
                   {languages}
                </Form.Control>
            </Form.Group>
        } else {
            var currentLanguageList = [];
            return <Form.Group controlId="exampleForm.ControlSelect1">
                {lable}
                <Form.Control style={this.props.style} as="select" onChange={this.updateLanguage.bind(this)}>
                    {this.state.languages.map(function(language){
                        if (currentLanguageList.indexOf(language.ietf) < 0){
                            currentLanguageList.push(language.ietf)
                            return <option value={language.ietf}>{Translation.get(language.name , language.basename)}</option>
                        } else {
                            return "";
                        }
                    })}
                </Form.Control>
            </Form.Group>
        }
    }

    disabled() {
        var lable = this.props.title ?   <Form.Label>{this.props.title}</Form.Label> : null;
        if (this.isDuplicates()) {
            var lable = this.props.title ?   
            [<Form.Label style={{width:"52%", float:"left"}}><b>{Translation.get(0, "Select Product")}</b></Form.Label>,
            <Form.Label style={{width:"48%", float:"right"}}>{this.props.title}</Form.Label>] : null;

            function clone(obj) {
                if (null == obj || "object" != typeof obj) return obj;
                var copy = obj.constructor();
                for (var attr in obj) {
                    if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
                }
                return copy;
            }

            var newStyle = clone(this.props.style);
            if (newStyle == null || newStyle == undefined) {
                newStyle = {};
            }
            newStyle.width = "48%";
            newStyle.float = "left";
            var getList = [];
            var curriculumTests = [];
            var languages = [];


            this.state.languages.map(function(language){
                if(getList.indexOf(language.curriculum_note) < 0) {
                    getList.push(language.curriculum_note);
                }
            })
            getList.sort();

            for (var i =0; i < getList.length; i++) {
                curriculumTests.push(<option value={getList[i]}>{getList[i]}</option>);
            }

            if (this.state.selectedCurricNote == undefined) {
                this.state.selectedCurricNote = getList[0];
            }

            var first = "";

            var languages = this.state.languages.map(function(language){
                if (language.curriculum_note != undefined && language.curriculum_note != "") {
                    if (language.curriculum_note != this.state.selectedCurricNote && this.state.selectedCurricNote != undefined) {
                        return "";
                    }
                    if (first == "") {
                        first = language.ietf+"-"+language.curriculumUid;
                    }
                    return <option value={language.ietf+"-"+language.curriculumUid}>{Translation.get(language.name , language.basename) + " - " + language.curriculum_note}</option>
                } else {
                    return <option value={language.ietf+"-"+language.curriculumUid}>{Translation.get(language.name , language.basename)}</option>
                }
            }.bind(this));

            if (first != "" && this.state.needUpdate == true) {
                this.state.needUpdate = false;
                this.updateLanguage({target:{value:first}});
            }

            return <Form.Group controlId="exampleForm.ControlSelect1">
                {lable}
                <Form.Control style={newStyle} as="select" onChange={function(event) {
                    this.setState({selectedCurricNote:event.target.value, needUpdate:true});
                }.bind(this)}>
                   {curriculumTests};
                </Form.Control>
                <span style={{width:"4%", float:"left", color:"#FFFFFF"}}>.</span>
                <Form.Control disabled style={newStyle} as="select" onChange={this.updateLanguage.bind(this)}>
                   {languages}
                </Form.Control>
            </Form.Group>
        } else {
            var currentLanguageList = [];
            return <Form.Group controlId="exampleForm.ControlSelect1">
                {lable}
                <Form.Control disabled style={this.props.style} as="select" onChange={this.updateLanguage.bind(this)}>
                    {this.state.languages.map(function(language){
                        if (currentLanguageList.indexOf(language.ietf) < 0){
                            currentLanguageList.push(language.ietf)
                            return <option value={language.ietf}>{Translation.get(language.name , language.basename)}</option>
                        } else {
                            return "";
                        }
                    })}
                </Form.Control>
            </Form.Group>
        }
    }

    render(){
        if (this.props.disabled == undefined) {
            return this.notDisabled();
        } else {
            return this.disabled();
        }
    }
}